import * as yup from 'yup';
import { ObjectShape } from 'yup/lib/object';

export const characterizationAverageReport = (
  t: (key: string, options?: { [key: string]: string }) => string,
): ObjectShape => {
  return {
    year: yup.date().typeError(t('validation.date.invalid')).nullable().required(t('validation.required')),
    month: yup.date().typeError(t('validation.date.invalid')).nullable().required(t('validation.required')),
  };
};
